import React, { useState, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import './ClassCardItem.css';

import {
  Avatar, Card, CardActionArea, CardActions, CardHeader,
  CardContent, IconButton, Grid, Menu,
  MenuItem, Tooltip, Typography
} from '@material-ui/core';

import {
  MoreVert as MoreVertIcon,
  FolderOpenTwoTone as FolderOpenTwoToneIcon,
  TrendingUpTwoTone as TrendingUpTwoToneIcon
} from '@material-ui/icons';

import ModalForm from '../Modals/ModalForm';
import { StateContext, DispatchContext } from '../../../../context/Provider';
import MoreIcon from '@material-ui/icons/MoreVert';

import { Button } from '@material-ui/core';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ConfirmPasswordModal from '../../../../components/Shared/ConfirmPasswordModal'

const ClassCardItem = (props) => {

  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const { authState } = appState;
  const { globalDispatch, facultyDispatch } = appDispatch;

  const useStyles = makeStyles({
    root: {
      // minWidth: 345
    },
    cardHeader: {
      paddingBottom: '35px',
      backgroundColor: props.themeColor ? props.themeColor : "#ff5722",
      backgroundSize: 'cover',
      color: '#fff'
    },
    cartTitle: {
      marginBottom: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    subHeader: {
      color: '#fff'
    },
    moreVertIcon: {
      color: '#fff'
    }
  });

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const openDropdown = Boolean(anchorEl);
  const [open, setOpen] = useState(false);
  const [classroom, setClassroom] = useState(null);

  const [classMenuAnchor, setClassMenuAnchor] = useState(null);
  const openClassMenuAnchor = Boolean(classMenuAnchor);

  const handleMenu = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClassMenu = (event) => {
    event.preventDefault();
    setClassMenuAnchor(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
    setClassMenuAnchor(null);
  };

  const handleDialog = () => {
    facultyDispatch({type: 'setDialogTitle', value: 'Edit Class'});
    facultyDispatch({type: 'setClassesClassID', value: props.classID});
    facultyDispatch({type: 'setClassesOpenDialog', value: true});
  };

  const handleOpenModal = () => {
    fetchClassroom(props.classID);
  }

  const handleCloseModal = () => {
    setOpen(false);
  }

  async function fetchClassroom(classID) {
    try {
      const response = await axiosConfig.get(`/classrooms/${classID}`);
      const { data } = response.data;

      setClassroom({
        name: data.name,
        section: data.section,
        subject: data.subject,
        room: data.room,
        theme_color: data.theme_color
      });

    } catch (e) {
      console.log(e);
    }

    setOpen(true);
  }

  async function removeClassroom(classID) {
    globalDispatch({type: 'setIsLoading', value: true});

    try {
      const response = await axiosConfig.post(`/classrooms/${classID}`, {
        _method: "DELETE"
      });

      const { status_code, message } = response.data;

      if (status_code === 'ok') {
        props.fetchClassrooms();
      }

    } catch (e) {
      console.log(e);
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  async function duplicateClassroom (classID) {
    globalDispatch({type: 'setIsLoading', value: true});
    handleClose()

    try {
      const response = await axiosConfig.post(`/classrooms/${classID}/duplicate`, {});
      const { status_code } = response.data;

      if (status_code == 'ok') {
        props.fetchClassrooms();
      }
    } catch (e) {
      console.log(e)
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  async function archiveClassroom (classID) {
    globalDispatch({type: 'setIsLoading', value: true});
    handleClose()

    try {
      const response = await axiosConfig.post(`/classrooms/${classID}/archive`, {});
      const { status_code } = response.data;

      if (status_code == 'ok') {
        props.fetchClassrooms();
      }
    } catch (e) {
      console.log(e)
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  async function unarchiveClassroom (classID) {
    globalDispatch({type: 'setIsLoading', value: true});
    handleClose()

    try {
      const response = await axiosConfig.post(`/classrooms/${classID}/unarchive`, {});
      const { status_code } = response.data;

      if (status_code == 'ok') {
        props.fetchClassrooms('archived');
      }
    } catch (e) {
      console.log(e)
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  const [openConfirmPasswordDialog, setOpenConfirmPasswordDialog] = useState(false)
  const [deletingClassroomID, setDeletingClassroomID] = useState(null)

  const closeConfirmPasswordDialog = () => {
    setOpenConfirmPasswordDialog(false)
  }

  const passwordDialogConfirmed = (classroomID) => {
    removeClassroom(classroomID)
    setOpenConfirmPasswordDialog(false)
  }


  return (
    <>
      { open ? (
        <ModalForm
          open={open}
          handleClose={handleCloseModal}
          dialogTitle={`Edit Class`}
          classID={props.classID}
          classroom={classroom}
          fetchClassrooms={props.fetchClassrooms}
        /> ) : null
      }

      <ConfirmPasswordModal
        title="Please confirm your password"
        message="Removing this participant will delete all activities and records of this student inside the class. To confirm this action, please enter your password."
        dialogState={openConfirmPasswordDialog}
        closeDialog={closeConfirmPasswordDialog}
        dialogConfirmed={(entityID) => {
          passwordDialogConfirmed(entityID);
        }}
        participantId={deletingClassroomID}
      />

      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
        <Card className={classes.root}>

          <CardActionArea
            disableRipple
            component="div"
          >
            <Link to={`/${props.classCode}/newsfeed`} className="unstyled-link">
              <CardHeader
                className={classes.cardHeader}
                avatar={
                  // except for faculty
                  authState.user.role_id !== 4 ? (
                    <Avatar aria-label="recipe" src={props.avatarPlaceholder}>F</Avatar>
                  ) : ''
                }
                action={
                  authState.user.role_id === 4 ? (
                    <IconButton
                      aria-label="settings"
                      onTouchStart={(event) => event.stopPropagation()}
                      onMouseDown={(event) => event.stopPropagation()}
                      onClick={handleMenu}
                    >
                      <MoreVertIcon className={classes.moreVertIcon} />
                    </IconButton>
                  ) : ''
                }
                title={<Typography className={classes.cartTitle} gutterBottom variant="h6" component="h2">{props.className}</Typography>}
                subheader={
                  <>
                    <Typography className={classes.subHeader} variant="body2" color="textSecondary" component="p">
                      {props.section}
                    </Typography>

                    {
                      // except for faculty
                      authState.user.role_id !== 4 ? (
                        <Typography className={classes.subHeader} variant="body1" color="textSecondary" component="p">
                          {props.facultyName || ''}
                        </Typography>
                      ) : ''
                    }
                  </>
                }
              />
            </Link>

            <Menu
              id="menu-cardheader"
              anchorEl={anchorEl}
              getContentAnchorEl={null} // this will display the popover below the icon
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "center"
              }}
              open={openDropdown}
              onClose={handleClose}
            >
              {/* <MenuItem onClick={handleClose}>Copy invitation link</MenuItem> */}
              <MenuItem onClick={() => { handleClose(); handleOpenModal(); }}>Edit</MenuItem>
              <MenuItem onClick={() => {
                // if (window.confirm(`Are you sure you want to permanently delete this classroom?`)) {
                //     handleClose();
                //     removeClassroom(props.classID);
                // }
                setDeletingClassroomID(props.classID)
                setOpenConfirmPasswordDialog(true)
              }}>
                Delete
              </MenuItem>
            </Menu>

            <CardContent style={{minHeight: '50px', display: 'flex', justifyContent: 'end'}}>
              <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClassMenu}
                endIcon={<ArrowDropDownIcon />}
              >
                Options
              </Button>
              { (props.isArchived)
              ? <Menu
                id="classw-menu"
                anchorEl={classMenuAnchor}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={openClassMenuAnchor}
                onClose={handleClose}
              >
                <MenuItem onClick={() => {
                  unarchiveClassroom(props.classID)
                }}>
                  Restore Class
                </MenuItem>
              </Menu>
              : <Menu
                id="classw-menu"
                anchorEl={classMenuAnchor}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={openClassMenuAnchor}
                onClose={handleClose}
              >
                <MenuItem onClick={() => window.open(`/${props.classCode}/meet/${authState.user.name}`, '_blank', 'noopener,noreferrer')}>
                  Join Meet
                </MenuItem>
                { authState.user.role_id !== 5 &&
                  <>
                    <MenuItem onClick={() => {
                      duplicateClassroom(props.classID)
                    }}>
                      Duplicate Class
                    </MenuItem>
                    <MenuItem onClick={() => {
                      archiveClassroom(props.classID)
                    }}>
                      Archive Class
                    </MenuItem>
                  </>
                }
              </Menu> }

              <Typography gutterBottom variant="h5" component="h2"></Typography>
              <Typography variant="body2" color="textSecondary" component="p"></Typography>
            </CardContent>
          </CardActionArea>
          {/* <CardActions>
            <Grid
              justify="flex-end"
              container
              spacing={1}
              // spacing={24}
            >
              <Grid item>
                <IconButton size="medium" aria-label="open folder">
                  <Tooltip title={`Open student record cards for "${props.className}"`}>
                    <TrendingUpTwoToneIcon />
                  </Tooltip>
                </IconButton>
              </Grid>

              <Grid item>
                <IconButton size="medium" aria-label="open folder">
                  <Tooltip title={`Open folder for "${props.className} ${props.section}"`}>
                    <FolderOpenTwoToneIcon />
                  </Tooltip>
                </IconButton>
              </Grid>
            </Grid>
          </CardActions> */}
        </Card>
      </Grid>
    </>
  );
}

export default ClassCardItem;